import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { IExam, IFileDownload, IExamQuestions } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { Subject } from 'rxjs';
import { Router, UrlSerializer } from '@angular/router';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { TableMode, GridComponent } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { EventService } from 'src/app/services/event-services/error-event.service';
@Component({
  selector: 'app-exam-questions',
  templateUrl: './exam-questions.component.html',
  styleUrls: ['./exam-questions.component.scss']
})
export class ExamQuestionsComponent implements OnInit {
  selectedQuestions: IExamQuestions[] = [];

  exam: IExam = examDefault;
  gridName = 'examQuestionsGrid';
  questionList: IExamQuestions[] = null;
  modelError = '';
  selectedQuestion: IExamQuestions = null;
  @ViewChild('gridComponent') gridComponent!: GridComponent;
  leftWidth = 550; // default width in px
  isDragging = false;
  startX = 0;
  startWidth = 0;
  constructor(private examService: ExamService, private router: Router, private snackBar: SnackbarService,
    private serializer: UrlSerializer, private cdRef: ChangeDetectorRef, private eventService: EventService) { }
  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [],
      sortParam: {
        fieldName: "",
        orderDirection: 0
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Question',
      fieldName: 'questionHtml',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Category',
      fieldName: 'category',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,
    },
    {
      displayName: 'Question Number',
      fieldName: 'questionNumber',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,
    },
    {
      displayName: 'Language',
      fieldName: 'language',
      fieldDataType: FieldDataType.enum,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Question Type',
      fieldName: 'questionType',
      fieldDataType: FieldDataType.enum,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Marks',
      fieldName: 'marks',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Disabled',
      fieldName: 'disabled',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Compulsory',
      fieldName: 'compulsory',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Question Group ID',
      fieldName: 'questionGroupID',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    }
  ];

  async ngOnInit() {
    // GridUtil.setClearGridSelection();
    this.examService.reloadGrid.subscribe((value) => {
      this.refreshData(this.data.tableParams);
    });
    this.examService.setSelectedQuestion([]);
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
      if (this.exam.useQuestionBank) {
        const questionSourceColumn: IColumn = {
          displayName: 'Question Source',
          fieldName: 'questionSource',
          fieldDataType: FieldDataType.text,
          searchable: true,
          orderable: true,
        };
        const existingColumn = this.columns.find(col => col.fieldName === 'questionSource');
        if (!existingColumn) {
          // Insert the column at index 1 (second position)
          this.columns.splice(2, 0, questionSourceColumn);
        }
      }

      await this.refreshData(this.data.tableParams);
    }
    this.leftWidth = parseInt(localStorage.getItem(`${this.gridName}_questionColumnWidth`)) || this.leftWidth;
  }

  updateGridParams(res: any) {
    if (!res) {
      return;
    }
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo }
    this.data.tableParams = tableParams;
    this.data.tableRows = res.slice(1, res.length);
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }

  async refreshData(tableParams) {
    tableParams.ExaminationID = this.examService.selectedExams[0].id ?? this.exam.id;
    const res = await this.examService.getExamQuestions(tableParams) as any[];
    this.updateGridParams(res);
  }

  emitQuestionData(quesIds: any[]) {
    if (!this.data?.tableRows) { //Just in case tableRows might still not be ready
      setTimeout(() => this.emitQuestionData(quesIds), 50);
      return;
    }
    const questionList: any[] = [];
    quesIds.forEach(x => questionList.push(this.data.tableRows[x]));
    this.selectedQuestions = questionList;
    this.selectedQuestion = this.selectedQuestions[0];
    this.examService.setSelectedQuestion([...this.selectedQuestions]);
    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    let selectedDataRowsId = storedIds.length > 0 ? storedIds : questionList.map(x => x.id);
    GridUtil.setRowCliclk(this.gridName, quesIds, selectedDataRowsId);
  }

  editQuestion() {
    let qID = this.examService.selectedQuestionsIds[0];
    this.router.navigate([`exams/${this.exam.id}/question`], { queryParams: { id: qID } });
  }

  getQuestionType(_type) {
    switch (_type) {
      case 'OptionsOnly':
        return 'Multiple-Choice';
      case 'OptionsAndEssay':
        return 'Multiple-Choice and Essay';
      default:
        return 'NotSet';
    }
  }

  addQuestion() {
    if (this.exam.useQuestionBank) {
      this.snackBar.success('Adding of Questions not supported, when use of question bank is checked!!');
      return;
    }
    this.gridComponent.resetRowSelected();
    this.selectedQuestion = {
      examinationQuestionID: 0,
      examinationID: 0,
      questionNumber: 0,
      questionType: '',
      questionHtml: '',
      category: '',
      marks: 1,
      disabled: false,
      penaltyMarks: 0,
      options: [],
      saqPossibleAnsers: '',
      language: 'en',
      maxWordCount: 0,
      languageEnum: '',
      compulsory: false,
      essaySubQuestions: []
    };
    this.cdRef.detectChanges();
  }

  deleteQuestion() {
    let data = { questionIds: this.examService.selectedQuestionsIds };
    const reportTree = this.router.createUrlTree([], { queryParams: data });
    let params = this.serializer.serialize(reportTree).split('?', 2)[1];

    this.examService.deleteQuestion(params).then(async s => {
      await this.refreshData(this.data.tableParams);
      this.snackBar.success('Question deleted successfully!!');
      this.addQuestion();
    });
  }

  async exportQuestionsClicked() {
    const res = await this.examService.exportQuest(this.exam.id, "Format1", "").then((res: IFileDownload) => {

      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', '' + 'data:application/octet-stream;base64,' + res.file);
      link.setAttribute('download', res.fileName + '.' + res.extension);
      document.body.appendChild(link);
      link.click();
      this.snackBar.success("Questions Exported successfully");
      link.remove();
    });
  }

  startDragging(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
    this.startX = event.clientX;
    this.startWidth = this.leftWidth;

    const mouseMove = (e: MouseEvent) => {
      if (!this.isDragging) return;

      const delta = e.clientX - this.startX;
      const newWidth = this.startWidth + delta;


      if (newWidth >= 350 && newWidth <= 1000) {
        this.leftWidth = newWidth;
        localStorage.setItem(`${this.gridName}_questionColumnWidth`, this.leftWidth.toString());
      }
    };

    const stop = () => {
      this.isDragging = false;
      document.removeEventListener("mousemove", mouseMove);
      document.removeEventListener("mouseup", stop);
    };

    document.addEventListener("mousemove", mouseMove);
    document.addEventListener("mouseup", stop);
  }

  // changeStatus(id) {
  //   this.examService.changeQuestionStatus(id).then(s => {
  //     this.snackBar.success('SUCCESSFULL!!');
  //     this.questionList.forEach(q => {
  //       if (q.examinationQuestionID == id) {
  //         q.disabled = !q.disabled;
  //       }
  //       return q;
  //     })
  //   });
  // }
}
